import { render, staticRenderFns } from "./Shouzhi.vue?vue&type=template&id=2f37a7e4&scoped=true&"
import script from "./Shouzhi.vue?vue&type=script&lang=js&"
export * from "./Shouzhi.vue?vue&type=script&lang=js&"
import style0 from "./Shouzhi.vue?vue&type=style&index=0&id=2f37a7e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37a7e4",
  null
  
)

export default component.exports